import { applyMiddleware, combineReducers, createStore, compose } from "redux";
import thunkMiddleware from "redux-thunk";

import actions from "./actions/reducer";
import caseDetail from "./caseDetail/reducer";
import caseIncident from "./incident/reducer";
import cases from "./cases/reducer";
import emergencyContact from "./emergencyContact/reducer";
import errorPage from "./errorPage/reducer";
import incidentTypes from "./incidentTypes/reducer";
import infoRequests from "./infoRequests/reducer";
import injuries from "./injuries/reducer";
import invitations from "./invitations/reducer";
import media from "./media/reducer";
import mediaPerpetrators from "./mediaPerpetrators/reducer";
import medicalRecords from "./medicalRecords/reducer";
import notes from "./notes/reducer";
import notifications from "./notifications/reducer";
import physicalDamage from "./physicalDamage/reducer";
import places from "./places/reducer";
import snackbar from "./snackbar/reducer";
import statements from "./statements/reducer";
import user from "./user/reducer";

const rootReducer = combineReducers({
  actions,
  caseDetail,
  caseIncident,
  cases,
  emergencyContact,
  errorPage,
  incidentTypes,
  infoRequests,
  injuries,
  invitations,
  media,
  mediaPerpetrators,
  medicalRecords,
  notes,
  notifications,
  physicalDamage,
  places,
  snackbar,
  statements,
  user
});

const composeEnhancer =
  process.env.NODE_ENV === "production"
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
  rootReducer,
  composeEnhancer(applyMiddleware(thunkMiddleware))
);
